import React from "react";
import { bool } from "prop-types";
import { useSelector } from "react-redux";
import { Watch } from "react-loader-spinner";
import Backdrop from "@mui/material/Backdrop";

import { LoadingIcon } from "./constants/images";

const Loader = ({ visible }) => {
  const active = useSelector((store) => store.app.visible);

  return ((visible || active) ? (
    <Backdrop
      open
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 99999999999999,
      }}
      onClick={() => {}}
    >

      <img src={LoadingIcon} />
    </Backdrop>
  ) : null);
};

Loader.propTypes = { visible: bool };
Loader.defaultProps = { visible: false };

export default Loader;
